var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { applyBannerThumbnailSize, applyOpenGraphThumbnailSize, classNames, firstStringProperty } from '@shapeable/utils';
import { EntityTypeHeader } from './entity-type-header';
import { ImageEntity } from './image-entity';
import { ResponsiveContainer } from '../elements/responsive-container';
import { DottedLine } from '../elements/dotted-line';
import { get } from 'lodash';
import { useLink } from '../hooks/use-link';
import { SmartMode } from '../context/theme-mode-context';
import { ExternalLinkIconGlyph } from '@shapeable/icons';
import { IconLabel } from '../elements/icon-label';
import { useLang } from '../hooks/use-lang';
import { pickBy } from 'lodash';
import { EntityStack } from './entity-stack';
import { animated, useSpring } from '@react-spring/web';
import { Badge } from '../elements/badge';
import { useReady } from '../hooks/use-ready';
import { useEntityUrl } from '../hooks/use-entity-url';
export var defaultEntityCardDescriptionPaths = ['summary.plain', 'summary.text', 'intro.plain', 'intro.text', 'description.plain', 'description.text', 'openGraph.description.plain', 'openGraph.description.text'];
var cls = classNames('entity-card');
export var EntityCardDefaultProps = {
  useEntityColorForBackground: false,
  showTypeHeader: true,
  useLink: true,
  variant: 'default',
  externaLinkLabel: 'Open Link',
  direction: 'column',
  color: 'text',
  descriptionPaths: defaultEntityCardDescriptionPaths,
  colorStripSize: 4,
  descriptionMaxLines: 5,
  colorStripColor: 'primary',
  linkStyles: {
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexGrow: 1
  },
  index: 1
};
// -------- Styles -------->
var BorderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n    ", "\n    transition: opacity 0.3s, box-shadow 0.3s;\n\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    border-radius: 0;\n\n    ", "\n\n    ", "\n  "], ["\n    \n    ", "\n    transition: opacity 0.3s, box-shadow 0.3s;\n\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    border-radius: 0;\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var variant = _a.variant;
    return variant !== 'chromeless' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      outline: 1px solid ", ";\n    "], ["\n      outline: 1px solid ", ";\n    "])), theme.COLOR('line-very-subtle'));
  }, function (_a) {
    var isLink = _a.isLink,
      variant = _a.variant;
    return isLink && variant !== 'chromeless' && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      &:hover {\n        box-shadow: 0 0 10px -3px ", ";\n      }\n    "], ["\n      &:hover {\n        box-shadow: 0 0 10px -3px ", ";\n      }\n    "])), theme.COLOR('subtle-shadow'));
  }, function (_a) {
    var direction = _a.direction;
    return direction === 'row' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
  }),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border-radius: 0 0 ", " ", ";\n  "], ["\n    border-radius: 0 0 ", " ", ";\n  "])), theme.UNIT(2), theme.UNIT(2))
});
var ContainerStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n    flex-grow: 1;\n    font-size: ", ";\n    line-height: 1.35em;\n    border-radius: 0;\n    flex-direction: column;\n    color: ", ";\n    width: 100%;\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    position: relative;\n    flex-grow: 1;\n    font-size: ", ";\n    line-height: 1.35em;\n    border-radius: 0;\n    flex-direction: column;\n    color: ", ";\n    width: 100%;\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.FONT_SIZE(13), theme.COLOR('text'), function (_a) {
    var colorStripSize = _a.colorStripSize,
      colorStripColor = _a.colorStripColor,
      color = _a.color,
      backgroundColor = _a.backgroundColor;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", ";\n      background: ", ";\n      border-top: ", "px solid ", ";\n    "], ["\n      color: ", ";\n      background: ", ";\n      border-top: ", "px solid ", ";\n    "])), theme.COLOR(color), theme.COLOR(backgroundColor), colorStripSize, theme.COLOR(colorStripColor));
  }, function (_a) {
    var variant = _a.variant;
    return variant === 'chromeless' && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      font-size: ", ";\n      font-weight: 300;\n    "], ["\n      font-size: ", ";\n      font-weight: 300;\n    "])), theme.FONT_SIZE(15));
  }, function (_a) {
    var isLink = _a.isLink,
      backgroundColor = _a.backgroundColor;
    return isLink && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      \n      ", ";\n\n      ", " {\n        outline-color: ", ";\n      }\n\n\n      ", " {\n        ", ";\n      }\n\n      ", " {\n        ", ";\n      }\n\n      &:hover {\n\n        ", " {\n          color: ", ";\n        }\n        \n        ", " {\n          outline-color: ", ";\n        }\n      \n        ", " {\n          filter: brightness(1.06);\n        }\n\n         ", "\n\n        color: ", ";\n        background-color: ", ";\n        \n        ", " {\n          filter: brightness(1.02);\n        }\n\n        ", " {\n          color: ", ";\n        }\n\n        ", " {\n          color: ", ";\n        }\n      }\n      \n    "], ["\n      \n      ", ";\n\n      ", " {\n        outline-color: ", ";\n      }\n\n\n      ", " {\n        ", ";\n      }\n\n      ", " {\n        ", ";\n      }\n\n      &:hover {\n\n        ", " {\n          color: ", ";\n        }\n        \n        ", " {\n          outline-color: ", ";\n        }\n      \n        ", " {\n          filter: brightness(1.06);\n        }\n\n         ", "\n\n        color: ", ";\n        background-color: ", ";\n        \n        ", " {\n          filter: brightness(1.02);\n        }\n\n        ", " {\n          color: ", ";\n        }\n\n        ", " {\n          color: ", ";\n        }\n      }\n      \n    "])), theme.TRANSITION('background-color', 'color', 'filter'), EntityStack.cls.child('bubble'), theme.COLOR(backgroundColor), cls.child('image-container'), theme.TRANSITION('filter'), cls.child('description'), theme.TRANSITION('filter'), EntityStack.cls.child(), theme.COLOR('strong'), EntityStack.cls.child('bubble'), theme.HOVER_COLOR(backgroundColor, 0.02), EntityStack.cls.child('bubble'), function (_a) {
      var variant = _a.variant;
      return variant !== 'chromeless' && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          ", ";\n        "], ["\n          ", ";\n        "])), theme.HOVER_SHADOW());
    }, theme.COLOR('strong'), theme.HOVER_COLOR(backgroundColor, 0.02), cls.child('image-container'), cls.child('description'), theme.COLOR('strong'), cls.child('type-header'), theme.COLOR('strong'));
  }),
  tablet: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", "\n\n    border-radius: 0 0 ", " ", ";\n\n    ", "\n  "], ["\n    ", "\n\n    border-radius: 0 0 ", " ", ";\n\n    ", "\n  "])), function (_a) {
    var direction = _a.direction;
    return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      flex-direction: ", ";\n    "], ["\n      flex-direction: ", ";\n    "])), direction);
  }, theme.UNIT(2), theme.UNIT(2), function (_a) {
    var direction = _a.direction;
    return direction === 'row' && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      \n      ", " {\n        width: 25%;\n        flex-shrink: 0;\n\n        img {\n          border-radius: 0 0 0 ", ";\n        }\n      }\n\n      ", " {\n        width: 75%;\n        flex-grow: 1;\n      }\n    "], ["\n      \n      ", " {\n        width: 25%;\n        flex-shrink: 0;\n\n        img {\n          border-radius: 0 0 0 ", ";\n        }\n      }\n\n      ", " {\n        width: 75%;\n        flex-grow: 1;\n      }\n    "])), cls.child('image-container'), theme.UNIT(2), cls.child('body'));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    /* Add visual balance by padding bottom more than top */\n    padding-bottom: ", ";\n "], ["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    /* Add visual balance by padding bottom more than top */\n    padding-bottom: ", ";\n "])), theme.UNIT(1))
});
var ImageStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    img {\n      transform: translateZ(0);\n    }\n  "], ["\n    img {\n      transform: translateZ(0);\n    }\n  "])))
});
var BadgeStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    position: absolute;\n    top: 12px;\n    right: 12px;\n  "], ["\n    position: absolute;\n    top: 12px;\n    right: 12px;\n  "])))
});
var HeadStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    padding: ", " ", " 0 ", ";\n  "], ["\n    padding: ", " ", " 0 ", ";\n  "])), theme.UNIT(4), theme.UNIT(4), theme.UNIT(4))
});
var FootStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding: 0 ", " ", " ", ";\n  "], ["\n    padding: 0 ", " ", " ", ";\n  "])), theme.UNIT(4), theme.UNIT(4), theme.UNIT(4))
});
var ContentStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    flex-grow: 1;\n  "], ["\n    padding: ", " ", " ", ";\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    flex-grow: 1;\n  "])), theme.UNIT(4), theme.UNIT(4), theme.UNIT(5), theme.UNIT(3))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    font-size: 1em;\n    \n    ", "\n  "], ["\n    font-size: 1em;\n    \n    ", "\n  "])), function (_a) {
    var maxLines = _a.maxLines;
    return maxLines && css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.MAX_LINES(maxLines));
  })
});
var TitlesStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(1))
});
var TitleStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n    margin: 0;\n    font-weight: 600;\n    font-size: ", "em;\n    line-height: 1.15em;\n    ", "\n\n  "], ["\n    ", ";\n    color: ", ";\n    margin: 0;\n    font-weight: 600;\n    font-size: ", "em;\n    line-height: 1.15em;\n    ", "\n\n  "])), theme.TRANSITION('color'), theme.COLOR('strong'), 16 / 13, function (_a) {
    var maxLines = _a.maxLines;
    return maxLines && css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.MAX_LINES(maxLines));
  }),
  tablet: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var lines = _a.lines;
    return lines && css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n      height: ", "em;\n    "], ["\n      height: ", "em;\n    "])), 1.15 * lines);
  })
});
var TypeHeaderStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n    font-size: ", "em;\n  "], ["\n    color: ", ";\n    ", ";\n    font-size: ", "em;\n  "])), theme.COLOR('sub'), theme.TRANSITION('color'), 12 / 13)
});
var ExternalLinkStyles = breakpoints({
  base: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    font-weight: 600;\n    ", ";\n  "], ["\n    font-weight: 600;\n    ", ";\n  "])), theme.FILL('strong'))
});
var PretitleStyles = breakpoints({
  base: css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MetaStyles = breakpoints({
  base: css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImageContainerStyles = breakpoints({
  base: css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.TRANSITION('filter', 'color'))
});
var DescriptionDividerStyles = breakpoints({
  base: css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var TitlesAndMetaStyles = breakpoints({
  base: css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Border: styled(animated.div).attrs(cls.attr('border'))(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), BorderStyles),
  Container: styled.div.attrs(cls.attr('container'))(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ImageContainer: styled(ResponsiveContainer).attrs(cls.attr('image-container'))(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  Image: styled(ImageEntity).attrs(cls.attr('image'))(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Badge: styled(Badge)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Head: styled.div.attrs(cls.attr('head'))(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  Content: styled.div.attrs(cls.attr('content'))(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  TitlesAndMeta: styled.div.attrs(cls.attr('titles-and-meta'))(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), TitlesAndMetaStyles),
  Titles: styled.div.attrs(cls.attr('titles'))(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  TypeHeader: styled(EntityTypeHeader).attrs(cls.attr('type-header'))(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), TypeHeaderStyles),
  Pretitle: styled.div.attrs(cls.attr('pretitle'))(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), PretitleStyles),
  Title: styled.h1.attrs(cls.attr('title'))(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Meta: styled.div.attrs(cls.attr('meta'))(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), MetaStyles),
  DescriptionDivider: styled(DottedLine)(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), DescriptionDividerStyles),
  Description: styled.div.attrs(cls.attr('description'))(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  OpenExternalLink: styled(IconLabel).attrs(cls.attr('external-link'))(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), ExternalLinkStyles),
  Foot: styled.div.attrs(cls.attr('foot'))(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), FootStyles)
};
export var EntityCardComponent = function (props) {
  var _a, _b, _c;
  var className = props.className,
    children = props.children,
    head = props.head,
    pretitle = props.pretitle,
    meta = props.meta,
    foot = props.foot,
    colorStripSize = props.colorStripSize,
    image = props.image,
    descriptionPaths = props.descriptionPaths,
    descriptionMaxLines = props.descriptionMaxLines,
    titleMaxLines = props.titleMaxLines,
    titleLines = props.titleLines,
    variant = props.variant,
    externaLinkLabel = props.externaLinkLabel,
    direction = props.direction,
    labelDeriver = props.labelDeriver,
    showTypeHeader = props.showTypeHeader,
    index = props.index,
    animate = props.animate;
  // by convention, if the entity has a color, assume we want to show the color strip by default, but it can be explicitly turned off
  var entity = applyOpenGraphThumbnailSize('card')(props.entity);
  // argh
  if (entity.banner) {
    entity = __assign(__assign({}, entity), {
      banner: applyBannerThumbnailSize('card')(entity.banner)
    });
  }
  var linkStyles = pickBy(__assign({
    width: direction === 'row' && '100%'
  }, props.linkStyles));
  var isReady = useReady();
  var styles = !animate || !isReady ? {
    opacity: 1
  } : useSpring({
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    },
    delay: index * 10,
    config: {
      duration: 0
    }
  });
  var description = firstStringProperty(entity, descriptionPaths);
  var title = firstStringProperty(entity, ['title', 'name']);
  var t = useLang();
  var backgroundColor = props.backgroundColor || props.useEntityColorForBackground && ((_a = entity === null || entity === void 0 ? void 0 : entity.color) === null || _a === void 0 ? void 0 : _a.value) || 'bright';
  var Link = useLink().Link;
  var href = useEntityUrl(entity);
  var hasImage = !!get(entity, 'image.url') || !!get(entity, 'openGraph.image.url') || !!get(entity, 'banner.url');
  var showImage = props.showImage === undefined ? hasImage : props.showImage;
  var showColorStrip = props.showColorStrip === undefined ? !!((_b = entity.color) === null || _b === void 0 ? void 0 : _b.value) && !(props.useEntityColorForBackground && direction === 'row') : props.showColorStrip;
  var colorStripColor = ((_c = entity.color) === null || _c === void 0 ? void 0 : _c.value) || props.colorStripColor;
  var showExternalLink = props.showExternalLink === undefined ? !!href && !!entity.url : props.showExternalLink;
  var showDescription = props.showDescription === undefined ? !!description : props.showDescription;
  var showMeta = props.showMeta === undefined ? !!meta : props.showMeta;
  var externalLinkIcon = props.externaLinkIcon || React.createElement(ExternalLinkIconGlyph, {
    size: 16
  });
  var badge = props.badge || (entity === null || entity === void 0 ? void 0 : entity.badge);
  var showBadge = props.showBadge === undefined ? !!badge : props.showBadge;
  var isLink = props.useLink && !!href;
  var inner = React.createElement(SmartMode, {
    bgColor: backgroundColor
  }, React.createElement(My.Container, {
    variant: variant,
    direction: direction,
    color: props.color,
    backgroundColor: backgroundColor,
    isLink: isLink,
    colorStripColor: colorStripColor,
    colorStripSize: showColorStrip ? colorStripSize : 0
  }, showImage && (image || React.createElement(My.ImageContainer, null, React.createElement(My.Image, {
    useThumbnail: true,
    entity: (entity === null || entity === void 0 ? void 0 : entity.banner) || (entity === null || entity === void 0 ? void 0 : entity.openGraph)
  }))), showBadge && badge && React.createElement(My.Badge, {
    showBorder: true
  }, t(badge)), React.createElement(My.Body, null, head && React.createElement(My.Head, null, head), React.createElement(My.Content, null, React.createElement(My.Titles, null, showTypeHeader && React.createElement(My.TypeHeader, {
    labelDeriver: labelDeriver,
    entity: entity
  }), pretitle && React.createElement(My.Pretitle, null, pretitle), title && React.createElement(My.Title, {
    lines: direction !== 'row' && titleLines,
    maxLines: titleMaxLines || titleLines
  }, title)), showMeta && React.createElement(My.Meta, null, meta), showDescription && React.createElement(React.Fragment, null, React.createElement(My.DescriptionDivider, {
    height: 2
  }), React.createElement(My.Description, {
    maxLines: descriptionMaxLines
  }, description)), children, showExternalLink && React.createElement(My.OpenExternalLink, {
    reverse: true,
    size: "inherit",
    icon: externalLinkIcon,
    iconSize: 16
  }, t(externaLinkLabel))), foot && React.createElement(My.Foot, null, foot))));
  return React.createElement(My.Border, {
    variant: variant,
    style: styles,
    className: cls.name(className),
    direction: direction,
    isLink: isLink
  }, isLink ? React.createElement(Link, {
    style: linkStyles,
    href: href
  }, inner) : inner);
};
EntityCardComponent.defaultProps = EntityCardDefaultProps;
export var EntityCard = React.memo(EntityCardComponent);
/* @ts-ignore */
EntityCard.cls = cls;
export var EntityCardChromeless = function (props) {
  return React.createElement(EntityCard, __assign({}, props, {
    variant: 'chromeless'
  }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51;